export default "__VITE_ASSET__Cs82DRpG__"